import axios from 'axios'

const searchApi =  axios.create({
    baseURL : 'https://api.mapbox.com/geocoding/v5/mapbox.places/',
    params: {
        limit: 5,
        language: 'es',
        access_token: 'pk.eyJ1Ijoib3NjYXJmcGF0YSIsImEiOiJjbGRxN2dkNDgwMTVkM29rZ2ZzNzFmY3A0In0.P3iRtuCzBq2opwTqrD8YQg'

    }

})

export default searchApi